export const ACADEMIC_YEAR = 'academicyear/' as const
export const ACADEMIC_YEAR_ACTIVATE = `${ACADEMIC_YEAR}activate/` as const
export const ACADEMIC_YEAR_ALL = `${ACADEMIC_YEAR}all` as const
